export const EventVODStatus = {
	UPLOADED:         'uploaded',
	UPLOAD_CANCELLED: 'upload_cancelled',
	VERIFYING:        'verifying',
	FINALIZING:       'finalizing',
	ENCODING:         'encoding',
	INAPPLICABLE:     'inapplicable', // default state
	UPLOADING:        'uploading', // manager upload started
	BUILDING:         'building', // video cloud task running
	PROCESSING:       'processing', // external processing (3q) running
	NO_SIGNAL:        'no_signal', // no signal received, final state
	AVAILABLE:        'available', // fully available, final state
	FAILURE:          'failure', // failed, final state
	DELETED:          'deleted', // vod deleted
};
